import {doPost} from "./api.js";

export const API_PERSONALIZATION = 'https://editor.flyerline.ch/personalization/computeUrl';

export class CreatexApi {

    getPersonalization (webproductId, templateId, configId, customer, locale = 'de_CH', customizedProductId = null ) {

        let params = {
            "success_url": window.location.href+"?configId="+configId,
            "cancel_url": window.location.href+"?configId="+configId,
            "webproduct": webproductId.toString(),
            "template_id": templateId.toString(),
            "customer": customer,
            "store_code": "default",
            "isLogin": "1",
            "locale": locale,
            "product_name": window.FlyerlineConfig.product_name
        }

        if( customizedProductId !== null )
        {
            params.customizedproductid = customizedProductId;
        }

        const searchParams = new URLSearchParams( params )
        const contentType = 'application/x-www-form-urlencoded;charset=UTF-8'

        return doPost(API_PERSONALIZATION, searchParams, contentType );
    }

}
